import TweenMax from 'gsap/TweenMax';

export default function Tow(container, canvas, duration, beforeAnimation) {
  const {
    top: containerTop,
    left: containerLeft,
    width: containerWidth,
  } = container.getBoundingClientRect();

  const { top: canvasTop, right: canvasRight } = canvas.getBoundingClientRect();

  const initialX = canvasRight - containerLeft - containerWidth / 2 + 25;
  const initialY = containerTop - canvasTop + 50;

  beforeAnimation(initialX, initialY);

  TweenMax.to(container, 0.25, {
    opacity: 1,
  });
}
